module.exports = __webpack_public_path__ + "9e636ff656ff80b145d12e9d0898d4df.gif";